import { render, staticRenderFns } from "./pi-button-select.vue?vue&type=template&id=48735c01&"
import script from "./pi-button-select.vue?vue&type=script&lang=ts&"
export * from "./pi-button-select.vue?vue&type=script&lang=ts&"
import style0 from "./pi-button-select.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports